export enum ErrorCode {
  RESPONSE_PARSING_ERROR = 'response_parsing_error',
  GRAPHQL_ERROR = 'graphql_error',
  BAD_REQUEST = 'bad_request',
  INVALID_TOKEN = 'invalid_token',
  INTERNAL_SERVER_ERROR = 'internal_server_error',
}
